/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface SetCustomerSpecificPricingForCompanyRequest
 */
export interface SetCustomerSpecificPricingForCompanyRequest {
  /**
   *
   * @type {string}
   * @memberof SetCustomerSpecificPricingForCompanyRequest
   */
  companyId: string;
  /**
   *
   * @type {boolean}
   * @memberof SetCustomerSpecificPricingForCompanyRequest
   */
  value: boolean;
}

/**
 * Check if a given object implements the SetCustomerSpecificPricingForCompanyRequest interface.
 */
export function instanceOfSetCustomerSpecificPricingForCompanyRequest(
  value: object,
): value is SetCustomerSpecificPricingForCompanyRequest {
  if (!("companyId" in value) || value["companyId"] === undefined) return false;
  if (!("value" in value) || value["value"] === undefined) return false;
  return true;
}

export function SetCustomerSpecificPricingForCompanyRequestFromJSON(
  json: any,
): SetCustomerSpecificPricingForCompanyRequest {
  return SetCustomerSpecificPricingForCompanyRequestFromJSONTyped(json, false);
}

export function SetCustomerSpecificPricingForCompanyRequestFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): SetCustomerSpecificPricingForCompanyRequest {
  if (json == null) {
    return json;
  }
  return {
    companyId: json["companyId"],
    value: json["value"],
  };
}

export function SetCustomerSpecificPricingForCompanyRequestToJSON(
  json: any,
): SetCustomerSpecificPricingForCompanyRequest {
  return SetCustomerSpecificPricingForCompanyRequestToJSONTyped(json, false);
}

export function SetCustomerSpecificPricingForCompanyRequestToJSONTyped(
  value?: SetCustomerSpecificPricingForCompanyRequest | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    companyId: value["companyId"],
    value: value["value"],
  };
}
